import { Injectable } from '@angular/core';
import { Query, Store, StoreConfig } from '@datorama/akita';
import produce from 'immer';
import { Product } from '../../shared';
import { ChargingStation } from '../charging-stations-section.model';


export interface ChargingStationsState {
  chargingStations: ChargingStation[];
}

@Injectable({ providedIn: 'root' })
export class ChargingStationsQuery extends Query<ChargingStationsState> {
  constructor(protected store: ChargingStationsStore) { super(store); }

  public getPossibleElectricityMeterUnits(chargingStationIds: number[]): Product[] {
    const chargingStations = this.getValue().chargingStations;
    return chargingStationIds
      .filter(csId => chargingStations.find(cs => cs.id === csId))
      .map(csId => chargingStations.find(cs => cs.id === csId))
      .map(cs => cs.possibleElectricityMeterUnits)
      .reduce((accumulator, value) => accumulator.concat(value), [])
      .filter((emu, i, arr) => arr.findIndex(item => item.id === emu.id) === i);
  }
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'chargingStationsState', producerFn: produce })
export class ChargingStationsStore extends Store<ChargingStationsState> {
  constructor() {
    super({ chargingStations: [] });
  }
}
